// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2akXB","content":"ManualTimeModal_content__36lE8"};